import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

// Matches the {{merge:<token>}} sentinel the merge-field palette copies to the clipboard.
const MERGE_TOKEN_REGEX = /\{\{merge:[^}]+\}\}/g;

/**
 * Highlights inline {{merge:<token>}} sentinels in the editor as blue chips, so a pasted merge field
 * is visually recognisable while authoring — matching the read-only filler view.
 *
 * Implemented as a view-only ProseMirror decoration (not a node): the document still stores the plain
 * sentinel text, so content round-trips losslessly through the HTML + sanitise persistence pipeline.
 */
export const MergeTokenHighlight = Extension.create({
  name: 'mergeTokenHighlight',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('mergeTokenHighlight'),
        props: {
          decorations(state) {
            const decorations: Decoration[] = [];
            state.doc.descendants((node, pos) => {
              const { text } = node;
              if (!node.isText || !text) return;
              MERGE_TOKEN_REGEX.lastIndex = 0;
              let match: RegExpExecArray | null;
              while ((match = MERGE_TOKEN_REGEX.exec(text)) !== null) {
                const from = pos + match.index;
                const to = from + match[0].length;
                decorations.push(Decoration.inline(from, to, { class: 'merge-field-token merge-field-token--inline' }));
              }
            });
            return DecorationSet.create(state.doc, decorations);
          },
        },
      }),
    ];
  },
});

export default MergeTokenHighlight;
